<template>
  <el-dialog title="查看" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
    <div>缺失的数据</div>
    <el-table :data="tableList" height="calc(100% - 71px)" border class="m-t-10">
      <el-table-column
        prop="deviceModel"
        label="设备型号"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        prop="deviceAge"
        label="设备年龄"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        prop="devicePrice"
        label="设备价格"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        prop="content"
        label="规格内容"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        prop="description"
        label="规格描述"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
    </el-table>
    <div class="tr">
      <el-pagination
        class="p-t-10 r"
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="page.pageno"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size.sync="page.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.recordCount"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'viewReconciliation',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  data() {
    return {
      tableList: [], // 列表数据
      page: {
        pageno: 1,
        pagesize: 10,
        recordCount: 0,
      }, // 分页数据
    }
  },
  methods: {
    /**
     * @description 搜索
     */
    getTableDataList() {},

    sizeChange() {
      this.page.pageNo = 1
      this.getTableDataList()
    },

    currentChange() {
      this.getTableDataList()
    },
  },
}
</script>

<style lang="scss" scoped>

/deep/ .el-dialog__body {
  height: 500px;
  padding: 10px 20px;
}

</style>
